
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","data-name":"vuesax/linear/buliding"}},[_c('path',{attrs:{"d":"M4.124 45.876h41.752","fill":"#292d32"}}),_c('path',{attrs:{"data-name":"Vector","d":"M35.452 4.124H14.548c-6.272 0-8.362 3.737-8.362 8.35v33.4h37.628v-33.4c0-4.613-2.091-8.35-8.362-8.35zM14.605 34.375h6.186M29.209 34.375h6.186M14.605 25h6.186M29.209 25h6.186M14.605 15.625h6.186M29.209 15.625h6.186","fill":"#fff"}})])])
          )
        }
      }
    